var cov_elo6wjkwx = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Slider/Slider.tsx",
      hash = "f410ee916697dacec7b89fc9bcbd5a5a3b1cc347",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Slider/Slider.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 30
        },
        end: {
          line: 16,
          column: 31
        }
      },
      "2": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 16
        }
      },
      "3": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 30,
          column: 5
        }
      },
      "4": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 50
        }
      },
      "5": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 48
        }
      },
      "6": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 54
        }
      },
      "7": {
        start: {
          line: 38,
          column: 29
        },
        end: {
          line: 38,
          column: 39
        }
      },
      "8": {
        start: {
          line: 39,
          column: 25
        },
        end: {
          line: 39,
          column: 35
        }
      },
      "9": {
        start: {
          line: 40,
          column: 16
        },
        end: {
          line: 40,
          column: 28
        }
      },
      "10": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 44,
          column: 5
        }
      },
      "11": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 56
        }
      },
      "12": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 69
        }
      },
      "13": {
        start: {
          line: 48,
          column: 32
        },
        end: {
          line: 48,
          column: 69
        }
      },
      "14": {
        start: {
          line: 52,
          column: 28
        },
        end: {
          line: 52,
          column: 38
        }
      },
      "15": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 41
        }
      },
      "16": {
        start: {
          line: 57,
          column: 59
        },
        end: {
          line: 57,
          column: 69
        }
      },
      "17": {
        start: {
          line: 58,
          column: 14
        },
        end: {
          line: 60,
          column: 66
        }
      },
      "18": {
        start: {
          line: 61,
          column: 23
        },
        end: {
          line: 61,
          column: 33
        }
      },
      "19": {
        start: {
          line: 63,
          column: 16
        },
        end: {
          line: 63,
          column: 69
        }
      },
      "20": {
        start: {
          line: 64,
          column: 16
        },
        end: {
          line: 64,
          column: 69
        }
      },
      "21": {
        start: {
          line: 66,
          column: 20
        },
        end: {
          line: 66,
          column: 48
        }
      },
      "22": {
        start: {
          line: 67,
          column: 25
        },
        end: {
          line: 67,
          column: 38
        }
      },
      "23": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 40
        }
      },
      "24": {
        start: {
          line: 69,
          column: 25
        },
        end: {
          line: 69,
          column: 40
        }
      },
      "25": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 40
        }
      },
      "26": {
        start: {
          line: 70,
          column: 25
        },
        end: {
          line: 70,
          column: 40
        }
      },
      "27": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 48
        }
      },
      "28": {
        start: {
          line: 72,
          column: 36
        },
        end: {
          line: 72,
          column: 48
        }
      },
      "29": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 56
        }
      },
      "30": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 79,
          column: 5
        }
      },
      "31": {
        start: {
          line: 77,
          column: 23
        },
        end: {
          line: 77,
          column: 51
        }
      },
      "32": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 46
        }
      },
      "33": {
        start: {
          line: 78,
          column: 30
        },
        end: {
          line: 78,
          column: 46
        }
      },
      "34": {
        start: {
          line: 83,
          column: 23
        },
        end: {
          line: 83,
          column: 33
        }
      },
      "35": {
        start: {
          line: 84,
          column: 22
        },
        end: {
          line: 84,
          column: 32
        }
      },
      "36": {
        start: {
          line: 85,
          column: 18
        },
        end: {
          line: 85,
          column: 43
        }
      },
      "37": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 71
        }
      },
      "38": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 48
        }
      },
      "39": {
        start: {
          line: 92,
          column: 65
        },
        end: {
          line: 92,
          column: 75
        }
      },
      "40": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 57
        }
      },
      "41": {
        start: {
          line: 93,
          column: 46
        },
        end: {
          line: 93,
          column: 57
        }
      },
      "42": {
        start: {
          line: 95,
          column: 25
        },
        end: {
          line: 95,
          column: 35
        }
      },
      "43": {
        start: {
          line: 96,
          column: 22
        },
        end: {
          line: 96,
          column: 78
        }
      },
      "44": {
        start: {
          line: 97,
          column: 18
        },
        end: {
          line: 97,
          column: 67
        }
      },
      "45": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 51
        }
      },
      "46": {
        start: {
          line: 102,
          column: 42
        },
        end: {
          line: 102,
          column: 52
        }
      },
      "47": {
        start: {
          line: 103,
          column: 21
        },
        end: {
          line: 103,
          column: 31
        }
      },
      "48": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 40
        }
      },
      "49": {
        start: {
          line: 105,
          column: 21
        },
        end: {
          line: 105,
          column: 40
        }
      },
      "50": {
        start: {
          line: 106,
          column: 18
        },
        end: {
          line: 106,
          column: 73
        }
      },
      "51": {
        start: {
          line: 107,
          column: 22
        },
        end: {
          line: 111,
          column: 5
        }
      },
      "52": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 119,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 15
          },
          end: {
            line: 16,
            column: 16
          }
        },
        loc: {
          start: {
            line: 16,
            column: 30
          },
          end: {
            line: 16,
            column: 31
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 45
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 24
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 56
          },
          end: {
            line: 45,
            column: 3
          }
        },
        line: 37
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        },
        loc: {
          start: {
            line: 47,
            column: 34
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 47
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        loc: {
          start: {
            line: 51,
            column: 31
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 51
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 37
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 56
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        },
        loc: {
          start: {
            line: 82,
            column: 18
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 82
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 17
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 91
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 11
          },
          end: {
            line: 120,
            column: 3
          }
        },
        line: 101
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        }],
        line: 41
      },
      "1": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 33
          }
        }, {
          start: {
            line: 41,
            column: 38
          },
          end: {
            line: 41,
            column: 47
          }
        }, {
          start: {
            line: 41,
            column: 51
          },
          end: {
            line: 41,
            column: 94
          }
        }],
        line: 41
      },
      "2": {
        loc: {
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 48,
            column: 69
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 48,
            column: 69
          }
        }, {
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 48,
            column: 69
          }
        }],
        line: 48
      },
      "3": {
        loc: {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 48,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 48,
            column: 10
          }
        }, {
          start: {
            line: 48,
            column: 14
          },
          end: {
            line: 48,
            column: 30
          }
        }],
        line: 48
      },
      "4": {
        loc: {
          start: {
            line: 58,
            column: 14
          },
          end: {
            line: 60,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 44
          }
        }, {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 66
          }
        }],
        line: 58
      },
      "5": {
        loc: {
          start: {
            line: 60,
            column: 49
          },
          end: {
            line: 60,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 60,
            column: 59
          },
          end: {
            line: 60,
            column: 61
          }
        }, {
          start: {
            line: 60,
            column: 64
          },
          end: {
            line: 60,
            column: 65
          }
        }],
        line: 60
      },
      "6": {
        loc: {
          start: {
            line: 63,
            column: 16
          },
          end: {
            line: 63,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 33
          },
          end: {
            line: 63,
            column: 65
          }
        }, {
          start: {
            line: 63,
            column: 68
          },
          end: {
            line: 63,
            column: 69
          }
        }],
        line: 63
      },
      "7": {
        loc: {
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 64,
            column: 33
          },
          end: {
            line: 64,
            column: 65
          }
        }, {
          start: {
            line: 64,
            column: 68
          },
          end: {
            line: 64,
            column: 69
          }
        }],
        line: 64
      },
      "8": {
        loc: {
          start: {
            line: 66,
            column: 30
          },
          end: {
            line: 66,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 66,
            column: 41
          },
          end: {
            line: 66,
            column: 43
          }
        }, {
          start: {
            line: 66,
            column: 46
          },
          end: {
            line: 66,
            column: 47
          }
        }],
        line: 66
      },
      "9": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 40
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 40
          }
        }],
        line: 69
      },
      "10": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 40
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 40
          }
        }],
        line: 70
      },
      "11": {
        loc: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 72,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 72,
            column: 48
          }
        }, {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 72,
            column: 48
          }
        }],
        line: 72
      },
      "12": {
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 20
          }
        }, {
          start: {
            line: 72,
            column: 24
          },
          end: {
            line: 72,
            column: 34
          }
        }],
        line: 72
      },
      "13": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        }],
        line: 76
      },
      "14": {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 46
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 46
          }
        }],
        line: 78
      },
      "15": {
        loc: {
          start: {
            line: 92,
            column: 22
          },
          end: {
            line: 92,
            column: 60
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 92,
            column: 36
          },
          end: {
            line: 92,
            column: 60
          }
        }],
        line: 92
      },
      "16": {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 57
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 57
          }
        }],
        line: 93
      },
      "17": {
        loc: {
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 20
          }
        }, {
          start: {
            line: 93,
            column: 24
          },
          end: {
            line: 93,
            column: 44
          }
        }],
        line: 93
      },
      "18": {
        loc: {
          start: {
            line: 96,
            column: 44
          },
          end: {
            line: 96,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 45
          },
          end: {
            line: 96,
            column: 54
          }
        }, {
          start: {
            line: 96,
            column: 58
          },
          end: {
            line: 96,
            column: 66
          }
        }, {
          start: {
            line: 96,
            column: 71
          },
          end: {
            line: 96,
            column: 77
          }
        }],
        line: 96
      },
      "19": {
        loc: {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 40
          }
        }, {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 40
          }
        }],
        line: 105
      },
      "20": {
        loc: {
          start: {
            line: 106,
            column: 21
          },
          end: {
            line: 106,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 106,
            column: 32
          },
          end: {
            line: 106,
            column: 40
          }
        }, {
          start: {
            line: 106,
            column: 43
          },
          end: {
            line: 106,
            column: 50
          }
        }],
        line: 106
      },
      "21": {
        loc: {
          start: {
            line: 109,
            column: 6
          },
          end: {
            line: 109,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 6
          },
          end: {
            line: 109,
            column: 14
          }
        }, {
          start: {
            line: 109,
            column: 19
          },
          end: {
            line: 109,
            column: 49
          }
        }],
        line: 109
      },
      "22": {
        loc: {
          start: {
            line: 109,
            column: 19
          },
          end: {
            line: 109,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 109,
            column: 33
          },
          end: {
            line: 109,
            column: 38
          }
        }, {
          start: {
            line: 109,
            column: 41
          },
          end: {
            line: 109,
            column: 49
          }
        }],
        line: 109
      },
      "23": {
        loc: {
          start: {
            line: 110,
            column: 6
          },
          end: {
            line: 110,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 110,
            column: 6
          },
          end: {
            line: 110,
            column: 15
          }
        }, {
          start: {
            line: 110,
            column: 19
          },
          end: {
            line: 110,
            column: 30
          }
        }, {
          start: {
            line: 110,
            column: 34
          },
          end: {
            line: 110,
            column: 41
          }
        }],
        line: 110
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Slider/Slider.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import Indicator from './Indicator';
import { sliderClass } from './styles';
import { per2value, value2per } from './utils';
import { isRTL } from '../config';
import { isFunc } from '../utils/is';
var DefaultValue = (cov_elo6wjkwx.s[0]++, {
  formatValue: function formatValue(v) {
    cov_elo6wjkwx.f[0]++;
    cov_elo6wjkwx.s[1]++;
    return v;
  }
});

var Slider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  var _super = _createSuper2(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    cov_elo6wjkwx.f[1]++;
    cov_elo6wjkwx.s[2]++;
    _this = _super.call(this, props);
    _this.parentElement = void 0;
    cov_elo6wjkwx.s[3]++;
    _this.state = {
      dragging: false,
      length: value2per(props.value, props.scale)
    };
    cov_elo6wjkwx.s[4]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_elo6wjkwx.s[5]++;
    _this.handleDrag = _this.handleDrag.bind(_assertThisInitialized(_this));
    cov_elo6wjkwx.s[6]++;
    _this.handleDragEnd = _this.handleDragEnd.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Slider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_elo6wjkwx.f[2]++;

      var _ref = (cov_elo6wjkwx.s[7]++, this.props),
          value = _ref.value,
          scale = _ref.scale;

      var _ref2 = (cov_elo6wjkwx.s[8]++, this.state),
          dragging = _ref2.dragging;

      var len = (cov_elo6wjkwx.s[9]++, scale.length);
      cov_elo6wjkwx.s[10]++;

      if ((cov_elo6wjkwx.b[1][0]++, prevProps.value !== value) || (cov_elo6wjkwx.b[1][1]++, !dragging) && (cov_elo6wjkwx.b[1][2]++, prevProps.scale[len - 1] !== scale[len - 1])) {
        cov_elo6wjkwx.b[0][0]++;
        cov_elo6wjkwx.s[11]++;
        // eslint-disable-next-line
        this.setState({
          length: value2per(value, scale)
        });
      } else {
        cov_elo6wjkwx.b[0][1]++;
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_elo6wjkwx.f[3]++;
      cov_elo6wjkwx.s[12]++;

      if ((cov_elo6wjkwx.b[3][0]++, el) && (cov_elo6wjkwx.b[3][1]++, el.parentElement)) {
        cov_elo6wjkwx.b[2][0]++;
        cov_elo6wjkwx.s[13]++;
        this.parentElement = el.parentElement;
      } else {
        cov_elo6wjkwx.b[2][1]++;
      }
    }
  }, {
    key: "length2value",
    value: function length2value(length) {
      cov_elo6wjkwx.f[4]++;

      var _ref3 = (cov_elo6wjkwx.s[14]++, this.props),
          scale = _ref3.scale,
          step = _ref3.step;

      cov_elo6wjkwx.s[15]++;
      return per2value(length, scale, step);
    }
  }, {
    key: "handleDrag",
    value: function handleDrag(mx, my) {
      cov_elo6wjkwx.f[5]++;

      var _ref4 = (cov_elo6wjkwx.s[16]++, this.props),
          scale = _ref4.scale,
          onDrag = _ref4.onDrag,
          value = _ref4.value,
          vertical = _ref4.vertical,
          onIncrease = _ref4.onIncrease;

      var m = (cov_elo6wjkwx.s[17]++, vertical ? (cov_elo6wjkwx.b[4][0]++, my / this.parentElement.clientHeight) : (cov_elo6wjkwx.b[4][1]++, mx / this.parentElement.clientWidth * (isRTL() ? (cov_elo6wjkwx.b[5][0]++, -1) : (cov_elo6wjkwx.b[5][1]++, 1))));

      var _ref5 = (cov_elo6wjkwx.s[18]++, this.state),
          length = _ref5.length;

      var min = (cov_elo6wjkwx.s[19]++, this.props.min ? (cov_elo6wjkwx.b[6][0]++, value2per(this.props.min, scale)) : (cov_elo6wjkwx.b[6][1]++, 0));
      var max = (cov_elo6wjkwx.s[20]++, this.props.max ? (cov_elo6wjkwx.b[7][0]++, value2per(this.props.max, scale)) : (cov_elo6wjkwx.b[7][1]++, 1));
      var newLength = (cov_elo6wjkwx.s[21]++, length + (vertical ? (cov_elo6wjkwx.b[8][0]++, -m) : (cov_elo6wjkwx.b[8][1]++, m)));
      var needIncrease = (cov_elo6wjkwx.s[22]++, newLength > 1);
      cov_elo6wjkwx.s[23]++;

      if (newLength < min) {
        cov_elo6wjkwx.b[9][0]++;
        cov_elo6wjkwx.s[24]++;
        newLength = min;
      } else {
        cov_elo6wjkwx.b[9][1]++;
      }

      cov_elo6wjkwx.s[25]++;

      if (newLength > max) {
        cov_elo6wjkwx.b[10][0]++;
        cov_elo6wjkwx.s[26]++;
        newLength = max;
      } else {
        cov_elo6wjkwx.b[10][1]++;
      }

      cov_elo6wjkwx.s[27]++;

      if ((cov_elo6wjkwx.b[12][0]++, needIncrease) && (cov_elo6wjkwx.b[12][1]++, onIncrease)) {
        cov_elo6wjkwx.b[11][0]++;
        cov_elo6wjkwx.s[28]++;
        onIncrease();
      } else {
        cov_elo6wjkwx.b[11][1]++;
      }

      cov_elo6wjkwx.s[29]++;
      this.setState({
        length: newLength,
        dragging: true
      });
      cov_elo6wjkwx.s[30]++;

      if (onDrag) {
        cov_elo6wjkwx.b[13][0]++;
        var newValue = (cov_elo6wjkwx.s[31]++, this.length2value(newLength));
        cov_elo6wjkwx.s[32]++;

        if (newValue !== value) {
          cov_elo6wjkwx.b[14][0]++;
          cov_elo6wjkwx.s[33]++;
          onDrag(newValue);
        } else {
          cov_elo6wjkwx.b[14][1]++;
        }
      } else {
        cov_elo6wjkwx.b[13][1]++;
      }
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd() {
      cov_elo6wjkwx.f[6]++;

      var _ref6 = (cov_elo6wjkwx.s[34]++, this.state),
          length = _ref6.length;

      var _ref7 = (cov_elo6wjkwx.s[35]++, this.props),
          scale = _ref7.scale;

      var value = (cov_elo6wjkwx.s[36]++, this.length2value(length));
      cov_elo6wjkwx.s[37]++;
      this.setState({
        length: value2per(value, scale),
        dragging: false
      });
      cov_elo6wjkwx.s[38]++;
      this.props.onChange(this.props.index, value);
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      cov_elo6wjkwx.f[7]++;

      var _ref8 = (cov_elo6wjkwx.s[39]++, this.props),
          autoHide = _ref8.autoHide,
          _ref8$formatValue = _ref8.formatValue,
          formatValue = _ref8$formatValue === void 0 ? (cov_elo6wjkwx.b[15][0]++, DefaultValue.formatValue) : _ref8$formatValue;

      cov_elo6wjkwx.s[40]++;

      if ((cov_elo6wjkwx.b[17][0]++, !formatValue) || (cov_elo6wjkwx.b[17][1]++, !isFunc(formatValue))) {
        cov_elo6wjkwx.b[16][0]++;
        cov_elo6wjkwx.s[41]++;
        return null;
      } else {
        cov_elo6wjkwx.b[16][1]++;
      }

      var _ref9 = (cov_elo6wjkwx.s[42]++, this.state),
          dragging = _ref9.dragging;

      var className = (cov_elo6wjkwx.s[43]++, sliderClass('result', ((cov_elo6wjkwx.b[18][0]++, !autoHide) || (cov_elo6wjkwx.b[18][1]++, dragging)) && (cov_elo6wjkwx.b[18][2]++, 'show')));
      var value = (cov_elo6wjkwx.s[44]++, formatValue(this.length2value(this.state.length)));
      cov_elo6wjkwx.s[45]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 98,
            columnNumber: 12
          }
        }, value)
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_elo6wjkwx.f[8]++;

      var _ref10 = (cov_elo6wjkwx.s[46]++, this.props),
          index = _ref10.index,
          disabled = _ref10.disabled,
          vertical = _ref10.vertical;

      var _ref11 = (cov_elo6wjkwx.s[47]++, this.state),
          length = _ref11.length;

      cov_elo6wjkwx.s[48]++;

      if (index === 1) {
        cov_elo6wjkwx.b[19][0]++;
        cov_elo6wjkwx.s[49]++;
        length = 1 - length;
      } else {
        cov_elo6wjkwx.b[19][1]++;
      }

      var style = (cov_elo6wjkwx.s[50]++, _defineProperty({}, vertical ? (cov_elo6wjkwx.b[20][0]++, 'height') : (cov_elo6wjkwx.b[20][1]++, 'width'), "".concat(length * 100, "%")));
      var className = (cov_elo6wjkwx.s[51]++, sliderClass('bar', (cov_elo6wjkwx.b[21][0]++, vertical) && (cov_elo6wjkwx.b[21][1]++, index === 1 ? (cov_elo6wjkwx.b[22][0]++, 'top') : (cov_elo6wjkwx.b[22][1]++, 'bottom')), (cov_elo6wjkwx.b[23][0]++, !vertical) && (cov_elo6wjkwx.b[23][1]++, index === 1) && (cov_elo6wjkwx.b[23][2]++, 'right')));
      cov_elo6wjkwx.s[52]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindElement,
          style: style,
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 114,
            columnNumber: 7
          }
        }, this.renderResult(),
        /*#__PURE__*/
        React.createElement("div", {
          className: sliderClass('bar-bg'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 116,
            columnNumber: 9
          }
        }),
        /*#__PURE__*/
        React.createElement(Indicator, {
          disabled: disabled,
          onDrag: this.handleDrag,
          onDragEnd: this.handleDragEnd,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 117,
            columnNumber: 9
          }
        }))
      );
    }
  }]);

  return Slider;
}(PureComponent);

Slider.defaultProps = DefaultValue;
export default Slider;